import {NavigateFunction} from "react-router-dom";

import * as models from "liberty-core/api/models";

import {AuthenticatedUser} from "lib/auth";

export function redirectToAppointments(
  navigate: NavigateFunction,
  campaignId: string | null,
  optionId: string | null,
  guestInfo: models.AppointmentGuestInfo | null,
  selectedPatientId: string | null,
  apptCampaigns: models.AppointmentCampaign[],
  toApptsIfInvalid = true,
  insuranceInfo?: {frontImage: File; backImage: File},
) {
  if (campaignId) {
    // Make sure campaignId is valid
    const apptCampaign = apptCampaigns.find((c) => c.id === campaignId);
    if (apptCampaign) {
      if (
        optionId &&
        !apptCampaign.appointmentOptions?.some(
          (option) => option.id === optionId,
        )
      ) {
        navigate(`/appointments`, {
          state: {
            invalidCampaignOrOptionIds: true,
          },
        });
        return;
      }
      const hasMoreThanOneOption =
        (apptCampaign.appointmentOptions?.length ?? 0) > 1;

      navigate(
        hasMoreThanOneOption
          ? "/appointments/select-option"
          : "/appointments/schedule",
        {
          state: {
            campaignName: apptCampaign.name ?? "",
            options: apptCampaign.appointmentOptions,
            selectedPatientId,
            guestInfo,
            apptCampaigns: [apptCampaign],
            appointmentType: apptCampaign.appointmentSettingType,
            selectedCampaignId: campaignId,
            selectedCampaignOptionId:
              optionId ||
              (hasMoreThanOneOption
                ? undefined
                : apptCampaign.appointmentOptions?.[0]?.id ?? ""),
            insuranceInfo,
          },
        },
      );
      return;
    }

    if (toApptsIfInvalid) {
      navigate(`/appointments`, {
        state: {
          invalidCampaignOrOptionIds: true,
        },
      });
      return;
    }
  }
  const uniqueAppointmentTypes =
    apptCampaigns
      .map((c) => c.appointmentSettingType)
      .filter(
        (type, i) =>
          apptCampaigns.findIndex((c) => c.appointmentSettingType === type) ===
          i,
      ) ?? [];
  if (uniqueAppointmentTypes?.length === 1) {
    navigate("/appointments/select-campaign", {
      state: {
        appointmentType: uniqueAppointmentTypes[0],
        selectedPatientId,
        guestInfo,
        apptCampaigns: apptCampaigns ?? [],
        insuranceInfo,
      },
    });
  } else {
    navigate("/appointments/new", {
      state: {
        selectedPatientId,
        guestInfo,
        apptCampaigns: apptCampaigns ?? [],
        insuranceInfo,
      },
    });
  }
}

export function redirectToParamsPage(
  navigate: NavigateFunction,
  redirectParams: URLSearchParams,
  authenticatedUser: AuthenticatedUser | null,
  apptCampaigns: models.AppointmentCampaign[],
) {
  const pageName = redirectParams.get("pageName")?.toUpperCase();
  if (pageName === "TAXREPORT") {
    navigate(`/profile/tax-report`);
  } else if (pageName === "INSURANCECARDS") {
    navigate(`/profile/insurance`);
  } else if (pageName === "TRANSFERIN") {
    navigate(`/profile/transfer-in`);
  } else if (pageName === "APPOINTMENTS") {
    const campaignId = redirectParams.get("campaignId");
    const optionId = redirectParams.get("optionId");
    if (authenticatedUser?.data.linkedPatients?.length) {
      if (campaignId) {
        const apptCampaign = apptCampaigns.find((c) => c.id === campaignId);
        if (apptCampaign) {
          if (optionId) {
            const isValidOptionId = apptCampaign.appointmentOptions?.some(
              (o) => o.id === optionId,
            );
            if (!isValidOptionId) {
              navigate(`/appointments`, {
                state: {
                  invalidCampaignOrOptionIds: true,
                },
              });
              return;
            }
          }
        } else {
          navigate(`/appointments`, {
            state: {
              invalidCampaignOrOptionIds: true,
            },
          });
          return;
        }
      }

      navigate(`/appointments/patient-selection?${redirectParams.toString()}`);
    } else {
      if (!campaignId && !optionId) {
        navigate(`/appointments?${redirectParams.toString()}`);
      } else {
        redirectToAppointments(
          navigate,
          campaignId,
          optionId,
          null,
          authenticatedUser?.data.patientId ?? "",
          apptCampaigns,
          true,
        );
      }
    }
  } else {
    navigate(`/`);
  }
}
